import { Menu } from "antd";
import { Link } from "react-router-dom";
import "./site-menu.css";

const DAF_SERVICE_URL = "https://service.general-trucks.com/";

function SiteMenu({
  mode = "horizontal",
  onItemClick,
  className = "",
  isFooter = false,
}) {
  const items = [
    {
      label: "Каталог",
      path: "/catalogue",
      key: "catalogue",
    },
    {
      label: (
        <a
          href={DAF_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="daf-menu-link"
        >
          Сервис DAF
        </a>
      ),
      key: "link",
    },
    {
      label: "О компании",
      key: "aboutus",
      path: "/aboutus",
    },
    {
      label: "Контакты",
      key: "contacts",
      path: "/contacts",
    },
  ];

  const handleClick = (e) => {
    if (onItemClick) {
      onItemClick(e);
    }
  };

  const footerItems = isFooter ? [items.slice(0, 2), items.slice(2)] : null;

  const menuClassName = `app-menu ${className} ${
    mode === "horizontal" ? "horizontal" : ""
  } ${isFooter ? "footer-menu" : ""}`;

  const renderFooterItem = (item) => {
    if (item.key === "link") {
      return (
        <a
          href={DAF_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-menu-link daf-menu-link"
        >
          Сервис DAF
        </a>
      );
    }

    return (
      <Link
        to={item.path}
        className="footer-menu-link"
        onClick={() => handleClick({ key: item.key })}
      >
        {item.label}
      </Link>
    );
  };

  if (isFooter) {
    return (
      <nav
        className="footer-menu-nav"
        itemScope
        itemType="https://schema.org/SiteNavigationElement"
      >
        <div className="footer-menu-grid">
          {footerItems.map((columnItems, columnIndex) => (
            <ul
              className={`${menuClassName} footer-menu-column`}
              key={`footer-column-${columnIndex}`}
            >
              {columnItems.map((item) => (
                <li className="footer-menu-item" key={item.key}>
                  {renderFooterItem(item)}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </nav>
    );
  }

  return (
    <nav
      className="nav"
      itemScope
      itemType="https://schema.org/SiteNavigationElement"
    >
      <Menu
        mode={mode}
        items={items.map((item) => ({
          ...item,
          label: item.path ? (
            <Link
              to={item.path}
              className="site-menu-link"
              onClick={() => handleClick({ key: item.key })}
            >
              {item.label}
            </Link>
          ) : item.label,
        }))}
        className={menuClassName}
        disabledOverflow={mode === "horizontal"}
      />
    </nav>
  );
}

export default SiteMenu;
